<template>
  <div>
    <navlist :navlist="about" />
    <div class="layout">
      <div class="title">
        <h1>
          便民
          <br />服务
        </h1>
        <h2></h2>
      </div>
      <div class="main">
        <ul>
          <li class="service" v-for="(item,i) in list" :key='i'>
            <router-link :to='"/service/"+it.id' class="service-item" v-for="(it,index) in item" :key='index' tag='span'>
              <i :style='"background:url(/static/uploads/"+it.img+") no-repeat center;background-size: 100%;"'></i>
              <p>{{it.title}}</p>
            </router-link>
            <!-- <span class="service-item">4050办理所需材料</span>
            <span class="service-item">城乡居民医疗保险</span>
            <span class="service-item">办理老年优待证</span>
            <span class="service-item">生育登记</span>
            <span class="service-item">犬只办理</span> -->
          </li>
          <!-- <li class="service">
            <span class="service-item">公共租赁房申请条件</span>
            <span class="service-item">低保户</span>
            <span class="service-item">低保边缘户</span>
            <span class="service-item">支出性贫困</span>
            <span class="service-item">临时救助</span>
            <span class="service-item"></span>
          </li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticleList } from "../api/index";
import navlist from "../components/nav";
import { log } from "util";
export default {
  components: {
    navlist
  },
  data() {
    return {
      about: [
        {
          path: "/service",
          name: "便民服务"
        }
      ],
      action: "service",
      list: []
    };
  },
  methods: {
    async getList() {
      let { action } = this;
      let { data } = await getArticleList({ action });
      //console.log(data);
      const n =6;
      let length = Math.ceil(data.data.length / n);

      for (let i = 0; i < length; i++) {
        // slice() 方法返回一个从开始到结束（不包括结束）选择的数组的一部分浅拷贝到一个新数组对象。且原始数组不会被修改。
        let temp = data.data.slice(i * n, i * n + n);
        this.list.push(temp);
      }
     // console.log(this.list)
    }
  },
  watch:{
    $route(to){
      console.log(to)
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style>
</style>